import { Component, Injector, Input, NgModule } from "@angular/core";
import { WebComponentInitializerService } from "../shared/web-component-initializer.service";
import { defineCustomElements } from "@dffedb/util/src";
import { DffedbMapComponent } from "./dffedb-map.component";

@NgModule({
    imports: [DffedbMapComponent],
    exports: [DffedbMapComponent],
    providers: []
})
export class DffedbMapModule {
    constructor(injector: Injector) {
        defineCustomElements("dffedb-map", DffedbMapComponent, { injector });
    }
}
